import { legsWithReservation } from '@utils/copy-reservations-parser'
import { updateJourneyLeg } from '@state/builders/journey-legs/helpers'

export const state = {
  allReservations: [],
  dismissedLegs: [],
}

export const mutations = {
  setReservationsToCopy(state) {
    state.allReservations = legsWithReservation()
  },
  deleteReservationsToCopy(state) {
    state.allReservations = []
    state.dismissedLegs = []
  },
  dismissCopyReservation(state, legId) {
    state.dismissedLegs.push(legId)
  },
}

export const actions = {
  setReservationToLeg({ commit }, { legId, rarsLegId, reservation }) {
    updateJourneyLeg({
      where: legId,
      data: {
        reservations: reservation.reservations,
        reservation_source: reservation.source,
        seats: reservation.seats,
        coach: reservation.coach,
        rars_leg_id: rarsLegId,
      },
    })
  },
}
